/**
 * Labstep
 *
 * @module services/optimistic
 * @desc Business logic for optimistic creates
 */

import type { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import { ReduxService } from 'labstep-web/services/redux.service';
import type { LabstepReduxState } from 'labstep-web/state/types';

export class OptimisticService {
  public static buildOptimisticBody = (
    entityName: string,
    body: Record<string, unknown>,
    state: LabstepReduxState,
  ) => {
    const optimisticBody: { [key: string]: unknown } = {};

    for (const key of Object.keys(body)) {
      if (key.endsWith('_id') || key.endsWith('_guid')) {
        let field = key.replace('_id', '').replace('_guid', '');
        if (
          field === 'variable_template' &&
          entityName === 'protocol_condition'
        ) {
          field = entityName;
        }
        optimisticBody[field] = {
          id: ReduxService.getEntityKey(
            field,
            String(body[key]),
            'id',
            state,
          ),
          guid: ReduxService.getEntityKey(
            field,
            String(body[key]),
            'guid',
            state,
          ),
        };
      } else {
        optimisticBody[key] = body[key];
      }
    }

    if (entityName === 'protocol_value') {
      if (
        optimisticBody.variable_template &&
        typeof optimisticBody.variable_template === 'object' &&
        'guid' in optimisticBody.variable_template &&
        (
          state.entities?.protocol_value.byId?.[
            (optimisticBody.variable_template as any).guid
          ] as ProtocolValue
        )?.name
      ) {
        optimisticBody.name = (
          state.entities?.protocol_value.byId?.[
            (optimisticBody.variable_template as any).guid
          ] as ProtocolValue
        )?.name;
      }
    }
    if (entityName === 'metadata') {
      if (
        optimisticBody.variable_template &&
        typeof optimisticBody.variable_template === 'object' &&
        'guid' in optimisticBody.variable_template &&
        (
          state.entities?.metadata.byId?.[
            (optimisticBody.variable_template as any).id
          ] as ProtocolValue
        )?.name
      ) {
        optimisticBody.name = (
          state.entities?.metadata.byId?.[
            (optimisticBody.variable_template as any).id
          ] as ProtocolValue
        )?.name;
      }
    }

    optimisticBody.variable_template_guid =
      body.variable_template_id || body.variable_template_guid;

    return optimisticBody;
  };
}
